import { ProfileContext } from 'application/adapters/context/Profile';
import { filterItemsByAudience, useShouldShowContent } from 'helpers/audiencehelper';
import { useContext } from 'react';
import { SituationBanner } from 'ui/components';

export const SituationBannerFeature: React.FC<Umbraco.SituationBanner> = ({ content }) => {
	const { audiences, isReady, audiencesFailed } = useContext(ProfileContext);
	const show = useShouldShowContent(content.properties.audiencePicker);

	if (!isReady) return null;

	const filteredSituations = filterItemsByAudience(
		content.properties.situationItems ?? [],
		audiences,
		(situation) => situation?.properties?.audiencePicker,
		audiencesFailed,
	).slice(0, content.properties.maximumSituationsShown);

	return show && filteredSituations.length > 0 ? <SituationBanner {...content?.properties} situationItems={filteredSituations} /> : null;
};
